import { FormikProps } from 'formik'
import { BusinessPlanDrawerFormTypeRow } from './BusinessPlanDrawerForm'
import { RichTextEditorFormik } from './RichTextEditorFormik'

export function BusinessPlanDrawerFormRichTextEditor<T>(
  props: BusinessPlanDrawerFormTypeRow & { formProps: FormikProps<T> }
) {
  return <RichTextEditorFormik {...props} />
}
